import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { IDefectList, IMasterDataListMap, IOperationsList, TOperationIssueAndMarkedLocations } from '@monorepo/types';
import * as _ from 'lodash';

@Component({
  selector: 'monorepo-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss'],
})
export class MultiSelectComponent implements OnInit, OnChanges {
  @Input() type: 'OPERATION_OR_DEFECT' | 'OPERATION_AND_DEFECT' = 'OPERATION_OR_DEFECT';
  @Input() lists: IMasterDataListMap[string]['list'] | TOperationIssueAndMarkedLocations[] = [];
  @Input() preSelectedList: IMasterDataListMap[string]['list'] | TOperationIssueAndMarkedLocations[] = [];
  @Input() showCategoryId = false;
  @Input() enableSearch: boolean = false;
  @Input() isMultiSelectedMode: boolean = true;
  @Output() selectedList = new EventEmitter<TCreateMultiSelectList[number]['data'][]>();

  multiSelectList: TCreateMultiSelectList = [];
  filterString: string = '';
  filteredList: TCreateMultiSelectList = [];

  trackByFn(index: number, item: TCreateMultiSelectList[number]) {
    return item.id;
  }

  ngOnInit(): void {
    console.log('lists', this.lists);
    this.multiSelectList = this.createMultiSelectList();
    this.filteredList = [...this.multiSelectList];
  }

  ngOnChanges(): void {
    this.multiSelectList = this.createMultiSelectList();
    this.filterDefects();
  }

  onSelect(id: string) {
    this.multiSelectList = this.multiSelectList.map((v) => {
      if (v.id === id) {
        return {
          ...v,
          selected: !v.selected,
        };
      }
      return v;
    });
    if (this.isMultiSelectedMode) {
      this.selectedList.emit(this.multiSelectList.filter((v) => v.selected).map((v) => v.data));
    } else {
      this.selectedList.emit(this.multiSelectList.filter((v) => v.selected && v.id === id).map((v) => v.data));
    }
  }

  getPreSelectedIdSet(list: IMasterDataListMap[string]['list'] | TOperationIssueAndMarkedLocations[]) {
    const preSelectedItemIds = new Set<string>();
    list.forEach((item) => {
      if (this.type === 'OPERATION_AND_DEFECT') {
        const listItem = item as TOperationIssueAndMarkedLocations;
        preSelectedItemIds.add(listItem.operation.id + '_' + listItem.issue.id);
      } else {
        const listItem = item as IOperationsList | IDefectList;
        preSelectedItemIds.add(listItem.id);
      }
    });
    return preSelectedItemIds;
  }

  createMultiSelectList() {
    const preSelectedItemIds = this.getPreSelectedIdSet(this.preSelectedList);
    return this.lists.map((item) => {
      if (this.type === 'OPERATION_AND_DEFECT') {
        const listItem = item as TOperationIssueAndMarkedLocations;
        const id = listItem.operation.id + '_' + listItem.issue.id;
        return {
          id,
          name: listItem.operation.name,
          selected: preSelectedItemIds.has(id),
          issue_name: listItem.issue.name,
          category_id: '',
          department: listItem.operation.department,
          data: listItem,
        };
      } else {
        const listItem = item as IOperationsList | IDefectList;
        return {
          id: listItem.id,
          name: listItem.name,
          selected: preSelectedItemIds.has(listItem.id),
          issue_name: '',
          category_id: listItem.category_id,
          data: listItem,
        };
      }
    });
  }

  filterDefects(): void {
    const newArray: typeof this.multiSelectList = [];
    this.multiSelectList.forEach((elem: any) => {
      if (elem.name.toLowerCase().includes(this.filterString.toLowerCase())) {
        newArray.push(elem);
      }
    });
    this.filteredList = newArray;
  }
}

export type TCreateMultiSelectList = ReturnType<MultiSelectComponent['createMultiSelectList']>;
